module.exports = __webpack_public_path__ + "static/img/ejklogo_01.9903379.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ejklogo_01.png
// module id = 79
// module chunks = 1